import React from 'react';

const HomeTitle = props => (
    <legend className="index_icon">{props.children}</legend>
);

export default HomeTitle;